import { makeCell, makeRowSet } from './gridUtill';

let fields = [];
let columns = [];

// 구분 컬럼
makeCell(1, [{ field: 'category', alias: '구분', indexExclusive: true }], fields, columns);

// 원료 컬럼
makeCell(1, [{ field: 'material', alias: '원료', indexExclusive: true }], fields, columns);

// Mw (g/mol) 컬럼
makeCell(1, [{ field: 'mw', alias: 'Mw (g/mol)', indexExclusive: true }], fields, columns);

// Density (g/cm3) 컬럼
makeCell(1, [{ field: 'density', alias: 'Density (g/cm3)', indexExclusive: true }], fields, columns);

// 비고 컬럼
makeCell(1, [{ field: 'remark', alias: '비고', indexExclusive: true }], fields, columns);

// 변경일시 컬럼
makeCell(1, [{ field: 'changed_dt', alias: '변경일시', indexExclusive: true }], fields, columns);

// 변경자 컬럼
makeCell(1, [{ field: 'changed_usr', alias: '변경자', indexExclusive: true }], fields, columns);

// 변경유형 컬럼
makeCell(1, [{ field: 'change_type', alias: '변경유형', indexExclusive: true }], fields, columns);

const rowSet = makeRowSet(fields);
const errorMessage = '변경 이력이 없습니다';
const hideCheckBar = true;

export { fields, columns, rowSet, errorMessage, hideCheckBar }; 